export { WindowService } from './window.service';
export { NgwWowService } from './wow.service';
//# sourceMappingURL=index.js.map